











































import { defineComponent, ref, useContext, onMounted } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { ProductForProductPageType } from '~/utils/types/ProductPage';
import { getFirstBookLabel, getSecondBookLabel } from '~/utils/helpers/product';
import { productBuyCTATrack } from '~/helpers/trackings/24orepro/products';
import HTMLContent from '~/components/solepro/HTMLContent.vue';
import AddToWishlist from '~/components/AddToWishlist.vue';
import ProductHeading from './ProductHeading.vue';
import { Breadcrumb } from '~/modules/catalog/types';
import SfBreadcrumbs from '~/modules/catalog/category/components/breadcrumbs/SfBreadcrumbs.vue';
import ClientOnly from 'vue-client-only';
import { manageScroll } from '~/utils/helpers/functions';

export default defineComponent({
   props: {
        product: {
            type: Object as PropType<ProductForProductPageType>
        },
        breadcrumbs: {
            type: Array as PropType<Breadcrumb[]>
        }
    },
    components:{
      HTMLContent,
      AddToWishlist,
         ClientOnly,
         ProductHeading,
         SfBreadcrumbs
    },
    setup(props) {
      const { product } = props || {};
      const { app: { i18n }, $fc, $cookies } = useContext();
      
      /**
       * @hot - Questo è solo per i non-libri, da testare poi con i libri se si rompe.
       * @todo: Mancano ancora i bundle, non si è ancora capito cosa fare.
       */

      const firstLabel = ref<String>('');
      const secondLabel = ref<String>('');
      
      onMounted(()=>{
         const varLength = (Array.from(document.querySelectorAll('.solepro-option-card')).length > 1) || (!!product.variants && product.variants.length > 1); // @TODO fare il conteggio in maniera decente
         firstLabel.value = getFirstBookLabel(product, i18n);
         secondLabel.value = getSecondBookLabel(product, i18n, $fc,varLength);
      })

        const hasOnlyBuyable = product.additionalProducts && product.additionalProducts.length>0 
        ? product.additionalProducts.every(p=>p.buyable) : product.buyable; 
        
      return {
         firstLabel,
         secondLabel,
         hasOnlyBuyable
      }

    },
    methods:{
      async manageScroll(evt){
         try {
            manageScroll(evt)
            const $t = this as any;
            await productBuyCTATrack($t.product);
         } catch(e) {
            console.error(e)
         }

      }
   },
})
